module.exports = __webpack_public_path__ + "media/images/error_page_robot-b8348360.png";